import { Flex } from '@chakra-ui/react';
import Logo from './Logo';
import { jsx as _jsx } from "react/jsx-runtime";

var Header = function Header(_ref) {
  var showText = _ref.showText;
  return /*#__PURE__*/_jsx(Flex, {
    w: "full",
    pb: showText ? '5' : '2',
    justify: showText ? 'flex-start' : 'center',
    e2eid: "components_Header_Flex",
    children: /*#__PURE__*/_jsx(Logo, {
      showText: showText,
      e2eid: "components_Header_Logo"
    })
  });
};

export default Header;